import {postObject} from "./api_common";

export const ENDPOINT_LOGIN = '/login'

export function login(email, password) {
    let url = process.env.REACT_APP_API_URL + ENDPOINT_LOGIN
    let postData = {
        email: email,
        password: password
    }
    return postObject(url, postData)
}